"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDmarketings;
exports.postDmarketing = postDmarketing;
var _RestHelper = _interopRequireDefault(require("../utils/RestHelper"));
function getDmarketings(contractId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/feedin/v0/directmarketing?contractAccountId=").concat(contractId));
}
function postDmarketing(payload) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/feedin/v0/directmarketing"), payload);
}